<!-- begin breadcrumb -->
<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Administración</li>
    <li class="breadcrumb-item active">Polizas</li>
</ol>
<!-- end breadcrumb -->
<!-- begin page-header -->
<h1 class="page-header"><i class="fas fa-wrench"></i> Administración <small> Pólizas</small></h1>
<!-- end page-header -->
<div class="scrollable">
    <panel [noButton]="true">
        @if(!editNew){
        <div class="d-flex align-items-center justify-content-between">
            <h5>Listado de Pólizas</h5>
            <div class="d-flex align-items-center gap-4">  
                <select class="form-select form-select-sm" [(ngModel)]="yearSelected" (change)="getPolicies()">
                    @for(year of years; track year){
                         <option [value]="year">{{year}}</option>
                    }
                 </select>
                 @if(listPolicies.length > 0){
                 <button class="btn btn-success btn-xs d-inline-flex align-items-center" (click)="editNew = true"><i class="fas fa-plus mx-1"></i>Nuevo</button>
                 }@else {
                    <button class="btn btn-success btn-xs d-inline-flex align-items-center text-nowrap" (click)="openPeriod()"><i class="fas fa-plus mx-1"></i>Abrir Periodo</button>
                 }
            </div>
        </div>
        
        <div class="row modal-body table-container mt-3 p-3">
            <div class="table-responsive">
            <table class="table table-sm table-hover">
                <thead class="fixed-header">
                    <tr>
                        <th>N°</th>
                        <th class="text-nowrap">Nombre</th>
                        <th class="text-center text-nowrap">Póliza</th>
                        <th class="text-center text-nowrap">RUT</th>
                        <th class="text-center text-nowrap">DV</th>
                        <th class="text-center text-nowrap">Vigencia</th>
                        <th class="text-center text-nowrap">Carga</th>
                        <th class="text-center text-nowrap">Cap. Variable</th>
                        <th class="text-center">Acción</th>
                    </tr>
                </thead>
                <tbody>
                    @for(p of listPolicies; track p; let i = $index){
                    <tr [ngClass]="{'table-danger': !p.enabled}">
                        <td>{{ i + 1 }}</td>
                        <td>{{p.entity.name}}</td>
                        <td class="text-center">{{p.code}}</td>
                        <td class="text-center">{{p.entity.rut | numberPipe}}</td>
                        <td class="text-center">{{p.entity.dv | uppercase}}</td>
                        <td class="text-center">{{p.year}}</td>
                        <td class="text-center">{{p.coverage.allowsDependents ? 'SI' : 'NO'}}</td>
                        <td class="text-center">{{p.coverage.allowUpgrade ? 'SI' : 'NO'}}</td>
                        <td class="text-center">
                            <button class="btn btn-warning btn-xs btn-rounded"
                                (click)="editPolicy = p; editNew = true"><i class="fas fa-edit"></i></button>
                        </td>

                    </tr>
                    }

                </tbody>
            </table>
            </div>
        </div>
        }@else{
            <div class="scrollable">
                <app-modal-policy [policy]="editPolicy" [year]="yearSelected" (refresh)="refreshData($event)"></app-modal-policy>
            </div>
        }
    
    </panel>
</div>
